<form [formGroup]="form">

<h2>
    {{ data?.incident ? 'Editar incidencia' : 'Registrar incidencia' }}
</h2>

  <div class="form-group">

    <label>Asistente</label>

    <input
      type="text"
      class="form-control"
      formControlName="asistente">

  </div>

  <div class="form-group mt-3">

    <label>Fecha</label>

    <input
      type="date"
      class="form-control"
      formControlName="fechaIncidencia">

  </div>

  <div class="form-group mt-3">

    <label>Incidencia</label>

    <input
      type="text"
      class="form-control"
      formControlName="titulo">

  </div>

  <div class="form-group mt-3">

    <label>Comentarios del cliente</label>

    <textarea
      rows="4"
      class="form-control"
      formControlName="comentariosSupervisor">
    </textarea>

  </div>
  
  <div class="form-group mt-3">

    <label>Comentarios MIA</label>

    <textarea
      rows="5"
      class="form-control"
      formControlName="comentarios">
    </textarea>

  </div>

  <div class="mt-4 text-right">

    <button
      type="button"
      class="btn btn-secondary mr-2"
      (click)="close()">

      Cancelar

    </button>

    <button
      type="button"
      class="btn btn-primary"
      (click)="save()">

      Guardar

    </button>

  </div>

</form>